module.exports = __webpack_public_path__ + "494cd07c/img/SOURCERY_poweredby_web.9819842b.png";